const UserNotificationTypeLabels = {
  SUPPORT_TICKET_ASSIGNMENT: 'Support ticket assignment',
  SUPPORT_TICKET_COMMENT: 'Support ticket comment',
};

export { UserNotificationTypeLabels };
